export const quotes = [
  {
    title:
      "I’m obsessed with perfection. I want to work. I dont’t want to take this for granted. - Drake",
    author: "Peter",
  },
  {
    title: "Connected communities where great ideas win.",
    author: "Nelson",
  },
  { title: "Have a great day at work", author: "Your friends at Exly" },
  {
    title: "“Whether you think you can, or think you can’t — you’re right.”",
    author: "Henry Ford",
  },
  {
    title: "“It’s not about ideas. It’s about making ideas happen.”",
    author: "Scott Belsky",
  },
  {
    title:
      "“Entrepreneur is someone who has a vision for something and a want to create.”",
    author: "David Karp",
  },
  {
    title: "“The way to get started is to quit talking and begin doing.”",
    author: "Walt Disney",
  },
  {
    title: "“High expectations are the key to everything.”",
    author: "Sam Walton",
  },
  {
    title:
      "“Don’t be afraid to assert yourself, have confidence in your abilities and don’t let the bastards get you down.”",
    author: "Michael Bloomberg",
  },
  {
    title:
      "“There are lots of bad reasons to start a company. But there’s only one good, legitimate reason, and I think you know what it is: it’s to change the world.”",
    author: "Phil Libin",
  },
  {
    title:
      "“If you’re passionate about something and you work hard, then I think you will be successful.”",
    author: "Pierre Omidyar",
  },
  {
    title:
      "“The secret to successful hiring is this: look for the people who want to change the world.”",
    author: "Marc Benioff",
  },
  {
    title:
      "“Your most unhappy customers are your greatest source of learning.”",
    author: "Bill Gates",
  },
  { title: "“Always deliver more than expected.”", author: "Larry Page" },
  {
    title:
      "“You can’t ask customers what they want and then try to give that to them. By the time you get it built, they’ll want something new.”",
    author: "Steve Jobs",
  },
  {
    title:
      "“Design is not just what it looks like and feels like. Design is how it works.”",
    author: "- Steve Jobs",
  },
  {
    title:
      "“Scientists never make any money.They’re always diluted into thinking that they live in a just universe that’ll reward them for their work”",
    author: "Peter Thiel",
  },
  {
    title:
      "“Many entrepreneurs focus only on short term growth. They have an excuse: growth is easy to measure, but durability isn’t.”",
    author: "Peter Thiel",
  },
  { title: "", author: "" },
];
